/* 🤖 this file was generated by svg-to-ts */
export const matIconChevronRight: {
  name: 'chevron-right';
  data: string;
} = {
  name: 'chevron-right',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"/></svg>`
};
